import { render, staticRenderFns } from "./PlaceAutocomplete.vue?vue&type=template&id=35e132bb&scoped=true&"
import script from "./PlaceAutocomplete.vue?vue&type=script&lang=js&"
export * from "./PlaceAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./PlaceAutocomplete.vue?vue&type=style&index=0&id=35e132bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e132bb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VAutocomplete,VListItem,VListItemTitle})
